import { CalculatorFormModel } from '../../../../../shared/models/view/CalculatorForm';
import { AppUtils } from '../../../../../shared/utils/index';

export class CalculatorModel extends CalculatorFormModel {

	private matchCandidateFailed: boolean;
	private checkTravel: boolean;
	private checkSaving: boolean;
	private checkProtection: boolean;
	private checkPlatinum: boolean;

	constructor() {
		super();
	}

	get MatchCandidateFailed(): boolean {
		return this.matchCandidateFailed;
	}

	set MatchCandidateFailed(value: boolean) {
		this.matchCandidateFailed = value;
	}

	get CheckTravel(): boolean {
		return this.checkTravel;
	}

	set CheckTravel(value: boolean) {
		this.checkTravel = value;
	}

	get CheckSaving(): boolean {
		return this.checkSaving;
	}

	set CheckSaving(value: boolean) {
		this.checkSaving = value;
	}

	get CheckProtection(): boolean {
		return this.checkProtection;
	}

	set CheckProtection(value: boolean) {
		this.checkProtection = value;
	}

	get CheckPlatinum(): boolean {
		return this.checkPlatinum;
	}

	set CheckPlatinum(value: boolean) {
		this.checkPlatinum = value;
	}


	/**
	* Creates a new Calculator Model object and copies the values from the provided data object (or other calculator model) to the created Calculator Model.
	*/
	public static createFromObject(dataObject: { [key: string]: any }): CalculatorModel {
		return AppUtils.Helper.createFromMap(dataObject, CalculatorModel);
	}
}